import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/bs.js';

import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import 'lightgallery/modules/lg-fullscreen.js';

import 'bootstrap-slider/dist/bootstrap-slider.js';

import 'select2';
import 'select2/dist/js/i18n/sr.js';

import lozad from 'lozad';

import functions from './js/functions.js';
import './js/globals.js';
import './js/list.js';
import './js/details.js';
import './js/booking.js';
import './js/contact.js';
import './js/inquiry.js';
import './js/bookingAddGuests.js';
import './js/analytics';

import './js/gutenberg/gutenberg.js';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6LeitgwoAAAAALtpc4QpNvflq8PKj2nyN7glm6qu');
    }
});
window.nobserver.observe();